<script setup lang="ts">
import Typography from '@components/Typography.vue';

interface PlusMenuItemProps {
  isActive?: boolean,
  hasPin?: boolean,
}

const { isActive = false, hasPin = false } = defineProps<PlusMenuItemProps>();
</script>

<template>
  <div
    class="plus-menu-item"
    :class="[
      isActive ? 'bg-blue-lightest' : 'hover:bg-blue-lightest',
      'rounded-lg',
      'h-14',
      'px-3',
      'flex items-center space-x-2',
      'select-none',
      'cursor-pointer',
    ]"
  >
    <div class="relative flex shrink-0">
      <slot name="icon" />

      <span
        v-if="hasPin"
        class="plus-menu-item__pin border border-solid border-white bg-red"
        :class="[
          'absolute right-0 top-0',
          'rounded-full',
          'size-3',
        ]"
      />
    </div>

    <Typography
      class="grow"
      :variant="isActive ? 'body-bold' : 'body'"
    >
      <slot name="text" />
    </Typography>
  </div>
</template>
